export const REGISTRATION_STEPS = {
  INTENT: "intent",
  PHONE: "phone",
  OTP: "otp",
  STUDENT_FORM: "student-form",
  SCHOOL_FORM: "school-form",
  SUCCESS: "success"
};

export const FLOW_TYPES = {
  STUDENT: "student",
  SCHOOL: "school"
};

export const INDIA_ISD = "+91";

export const SCHOOL_ROLE_OPTIONS = [
  { id: "principal", name: "Principal", value: "Principal" },
  { id: "teacher", name: "Teacher", value: "Teacher" },
  { id: "management", name: "Management", value: "Management" }
];

